export class AccountAuthorization {



    constructor(private _id?: number, private _remark?: string, private _granted_until?: Date, private _granted_remark?: string, private _created_at?: Date, private _created_by?: string,
        private _granted_by?: string, private _customer_account_id?: number, private _customerName?: string, private _customerIC?: string, private _revoked_remark?: string, private _revoked_by?: string, private _revoked_on?: string) { }

    get GrantedRemark(): string {
        return this._granted_remark;
    }
    set GrantedRemark(value: string) {
        this._granted_remark = value;
    }
    get GrantedUntil(): Date {
        return this._granted_until;
    }
    set GrantedUntil(value: Date) {
        this._granted_until = value;
    }
    get Remark(): string {
        return this._remark;
    }
    set Remark(value: string) {
        this._remark = value;
    }
    get ID(): number {
        return this._id;
    }
    set ID(value: number) {
        this._id = value;
    }

    get CustomerAccountId(): number {
        return this._customer_account_id;
    }
    set CustomerAccountId(value: number) {
        this._customer_account_id = value;
    }
    get GrantedBy(): string {
        return this._granted_by;
    }
    set GrantedBy(value: string) {
        this._granted_by = value;
    }
    get CreatedBy(): string {
        return this._created_by;
    }
    set CreatedBy(value: string) {
        this._created_by = value;
    }
    get CreatedAt(): Date {
        return this._created_at;
    }
    set CreatedAt(value: Date) {
        this._created_at = value;
    }

    get CustomerIC(): string {
        return this._customerIC;
    }
    set CustomerIC(value: string) {
        this._customerIC = value;
    }
    get CustomerName(): string {
        return this._customerName;
    }
    set CustomerName(value: string) {
        this._customerName = value;
    }
    get RevokedRemark(): string {
        return this._revoked_remark;
    }
    set RevokedRemark(value: string) {
        this._revoked_remark = value;
    }
    get RevokedOn(): string {
        return this._revoked_on;
    }
    set RevokedOn(value: string) {
        this._revoked_on = value;
    }
    get RevokedBy(): string {
        return this._revoked_by;
    }
    set RevokedBy(value: string) {
        this._revoked_by = value;
    }

}


export interface IAPIAccountAuthorization {
    id: number,
    remark: string,
    granted_until: Date,
    granted_remark: string,
    revoked_remark: string
}


